module.exports = __webpack_public_path__ + "static/media/1 (1).4c7aa2d0.png";